import { useState } from 'react'

export default function BetaBanner() {
  const [dismissed, setDismissed] = useState(false)
  if (dismissed) return null

  return (
    <div className="bg-kart-blue text-white text-sm py-2.5 px-4 flex items-center">
      <div className="w-6 shrink-0" />
      <span className="flex-1 text-center">🏁 KartQuiz est en bêta : <strong>100 % gratuit</strong> pendant cette période.</span>
      <button
        onClick={() => setDismissed(true)}
        aria-label="Fermer le bandeau"
        className="w-6 shrink-0 text-white/70 hover:text-white transition"
      >
        ✕
      </button>
    </div>
  )
}
